module.exports = __webpack_public_path__ + "img/1.c25ef5b7.png";